import { useEffect } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { Toaster } from './components/ui/sonner';
import { AuthProvider } from './context/AuthContext';
import { StaffAuthProvider } from './context/StaffAuthContext';
import { PartnerAuthProvider } from './context/PartnerAuthContext';
import ErrorBoundary from './components/ErrorBoundary';
import Home from './pages/Home';
import { Terms, Privacy, Cookies, ModernSlavery } from './pages/Legal';

// CRM
import CrmLogin from './pages/crm/Login';
import CrmLayout from './pages/crm/Layout';
import CrmLeads from './pages/crm/Leads';
import CrmPartners from './pages/crm/Partners';
import CrmStaff from './pages/crm/Staff';
import CrmReports from './pages/crm/Reports';
import CrmApplications from './pages/crm/Applications';
import CrmComplaints from './pages/crm/Complaints';

// Partner portal
import PartnerLogin from './pages/partner/Login';
import PartnerSignup from './pages/partner/Signup';
import PartnerLayout from './pages/partner/Layout';
import PartnerDashboard from './pages/partner/Dashboard';
import PartnerNewLead from './pages/partner/NewLead';

function App() {
  useEffect(() => {
    document.documentElement.style.scrollBehavior = 'smooth';
  }, []);

  return (
    <div className="App">
      <ErrorBoundary>
        <BrowserRouter>
          <AuthProvider>
            <StaffAuthProvider>
              <PartnerAuthProvider>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/terms" element={<Terms />} />
                  <Route path="/privacy" element={<Privacy />} />
                  <Route path="/cookies" element={<Cookies />} />
                  <Route path="/modern-slavery" element={<ModernSlavery />} />

                  <Route path="/crm/login" element={<CrmLogin />} />
                  <Route path="/crm" element={<CrmLayout />}>
                    <Route index element={<Navigate to="leads" replace />} />
                    <Route path="leads" element={<CrmLeads />} />
                    <Route path="partners" element={<CrmPartners />} />
                    <Route path="reports" element={<CrmReports />} />
                    <Route path="applications" element={<CrmApplications />} />
                    <Route path="complaints" element={<CrmComplaints />} />
                    <Route path="staff" element={<CrmStaff />} />
                  </Route>

                  <Route path="/partner/login" element={<PartnerLogin />} />
                  <Route path="/partner/signup" element={<PartnerSignup />} />
                  <Route path="/partner" element={<PartnerLayout />}>
                    <Route index element={<PartnerDashboard />} />
                    <Route path="leads/new" element={<PartnerNewLead />} />
                  </Route>
                </Routes>
              </PartnerAuthProvider>
            </StaffAuthProvider>
          </AuthProvider>
          <Toaster position="top-center" />
        </BrowserRouter>
      </ErrorBoundary>
    </div>
  );
}

export default App;
